import React, { useEffect, useMemo, useState } from "react";
import {
	requestAccountRecoverWithType,
	showMessageRecoverFailed,
} from "../../../store/modules/recoverPassword/actions";
import { useDispatch, useSelector } from "react-redux";
import { isMobile, regexEmail, validatingMaxBrazilianPhoneLength } from "../../../utils";
import { isCPFValid } from "../../../utils/validator";
import { toast } from "react-toastify";
import {
	Container,
	InputCpf,
	Content,
	Title,
	FormGroupInput,
	Label,
	Subtitle,
	DivButton,
	InputText,
	ButtonActive,
	ButtonInactive,
	MessageError,
	HelpContainer,
	TitleHelp,
	FormSupport,
	Wrapper,
	FormSubmit,
	Box,
} from "./styles";
import "../../../index.scss";
import Phone from "../../../components/welcome/phone";
import Recaptcha from "../../../components/Recaptcha";
import { MAIL_TEMPLATE } from "../constants/mail-template";
import useDevice from "../../../hook/useDevice";
import TmPopover from "../../../shared/components/Popover";
import TmPopoverHeader from "../../../shared/components/Popover/PopoverHeader";
import TmPopoverBody from "../../../shared/components/Popover/PopoverBody";
import Input from "../../../shared/components/Input";
import Select from "../../../shared/components/Select";
import Button from "../../../shared/components/Button";
import { Controller, useForm } from "react-hook-form";
import { FILDS_ZENDEKS } from "../../Welcome/constants/welcome.const";
import OnboardStep from "../../OnboardStep";
import { sendTicket } from "../../../store/modules/register/actions";

export default function OnboardForgotPassword() {
	const dispatch = useDispatch();
	const device = useDevice();
	const isDesktop = useDevice().isDesktop;

	const { recoverFail, loading } = useSelector((state) => state.recoverPassword);
	const [doc, setDoc] = useState("");
	const [valueDocument, setValueDocument] = useState("");
	const [telephone, setTelephone] = useState("");
	const [email, setEmail] = useState("");
	const [inputCpfValid, setInputCpfValid] = useState(true);
	const [disableInputs, setDisableInputs] = useState(true);
	const [disableButton, setDisableButton] = useState(true);
	const [isValidCaptcha, setIsValidCaptcha] = useState(false);
	const [selectRecover, setSelectedRecover] = useState("SMS");
	const [statusError, setStatusError] = useState("");
	const [maskCpf, setMaskCpf] = useState("");
	const [phoneInvalid, setPhoneInvalid] = useState("");
	const [tokenRecaptcha, setTokenRecaptcha] = useState(null);
	const [selectedField, setSelectedField] = useState("");
	const [statePopover, setStatePopover] = useState(undefined);
	const [isDataEmpty, setIsDataEmpty] = useState(true);

	const {
		register,
		handleSubmit,
		setValue,
		setError,
		clearErrors,
		watch,
		reset,
		resetField,
		formState,
		control,
	} = useForm();

	const { alternative } = watch();

	const { ticketSent, ticketLoading } = useSelector((state) => state.register);

	useEffect(() => {
		const value = telephone.replace(/\D/g, "");

		(regexEmail.test(email.toLowerCase()) || value.length > 10) && isValidCaptcha
			? setDisableButton(false)
			: setDisableButton(true);
	}, [email, telephone, isValidCaptcha]);

	useEffect(() => {
		if (ticketSent) {
			setStatePopover(true);
		}
	}, [ticketSent]);

	useEffect(() => {
		setSelectedField(alternative || "Telefone/E-mail");

		["oldData", "newData"].forEach((item) => resetField(item));
	}, [alternative]);

	useEffect(() => {
		const { unsubscribe } = watch((value) => {
			setIsDataEmpty(
				Object.values(value).some(
					(item) =>
						item == null ||
						(typeof item === "string" &&
							item.replace(/[^a-zA-Z0-9]/g, "").trim() === "")
				)
			);

			Object.entries(value).forEach(([field, value]) => {
				if (value) {
					handleValidField(value, field);
				}
			});
		});
		return () => unsubscribe();
	}, [watch]);

	function sendPhone() {
		let recoveryInfoType = "";
		let recoveryInfo = "";
		if (inputCpfValid) {
			if (selectRecover === "SMS") {
				const newValue = telephone.replace(/\D/g, "");
				if (!Boolean(newValue)) {
					toast.error(
						"Informe o seu número de celular para enviarmos o código de validação."
					);
					return;
				}
				recoveryInfoType = "phone_mobile";
				recoveryInfo = newValue;
			} else {
				if (!Boolean(email)) {
					toast.error(
						"Informe o seu e-mail para enviarmos o código de validação."
					);
					return;
				}
				recoveryInfoType = "email";
				recoveryInfo = email;
			}
			dispatch(
				requestAccountRecoverWithType(
					valueDocument,
					doc,
					recoveryInfoType,
					recoveryInfo.toLowerCase(),
					"",
					tokenRecaptcha
				)
			);
		} else {
			toast.error(`Insira um ${doc} válido!`);
			return;
		}
	}

	// function changeDocument(doc) {
	//     if (doc == 'CPF') { //CPF -> RNE
	//         setDoc('RNE')
	//         setLabelButton('Usar CPF')
	//         setPlaceHolderInput('Digite seu RNE')
	//         setStatusError('');
	//         setValueDocument('');
	//     } else { // RNE -> CPF
	//         setDoc('CPF')
	//         setLabelButton('Sou estrangeiro')
	//         setPlaceHolderInput('Digite seu CPF')
	//         setStatusError('');
	//         setValueDocument('');
	//     }
	// }

	function validDocument({ value }) {
		setMaskCpf("");
		if (value.length >= 11) {
			const isValid = isCPFValid(value.replace(/\.|-/g, ""));
			if (isValid && value.length > 0) {
				const CPF = value.replace(/\.|-/g, "");
				setValueDocument(CPF);
				setInputCpfValid(true);
				setDisableInputs(false);
				setStatusError("");
				setMaskCpf("999.999.999-99");
				setDoc("CPF");
			} else {
				setInputCpfValid(false);
				setStatusError(`Digite um documento válido`);
				setDisableInputs(true);
				setMaskCpf("");
			}
		} else {
			if (value.length > 1 && value.length < 11) {
				setValueDocument(value.replace(/\.|-/g, ""));
				setInputCpfValid(true);
				setDisableInputs(false);
				setStatusError("");
				setMaskCpf("");
				setDoc("RNE");
			} else {
				setMaskCpf("");
				setInputCpfValid(false);
				setStatusError(`Digite um documento válido`);
				setDisableInputs(true);
			}
		}
	}

	function onChangeCpf(value) {
		setValueDocument(value);
	}

	function selectOptionRecover(method) {
		dispatch(showMessageRecoverFailed(false));
		if (method === "SMS") {
			setEmail("");
			setSelectedRecover("SMS");
		} else {
			setTelephone("");
			setSelectedRecover("email");
		}
	}

	function handleClick() {
		if (device.isMobile) {
			return (window.location.href = MAIL_TEMPLATE);
		}
	}

	function submit(formData) {
		const { alternative, document, dtBirthday, newData, oldData, user, userContact } = formData;

		const payload = {
			ticket: {
				subject: "Solicitação de alteração cadastral - Recuperação de Senha",
				comment: {
					body: `Olá! Estou tentando resgatar a minha senha, mas mudei meus dados cadastrais.\r\nEstou tentando alterar o meu ${alternative}.\r\n Meus dados:\n\t Nome: ${user}\n\t CPF: ${document}\n\t Email/Telefone antigo: ${oldData}\n\t Email/Telefone novo: ${newData}\n\t Data de nascimento: ${dtBirthday}`,
				},
				via: {
					channel: "web",
				},
				status: "open",
				requester: {
					name: user,
					email: alternative === "Telefone" ? userContact : newData,
				},
				tags: ["chatbot_off"],
				custom_fields: [
					{
						id: FILDS_ZENDEKS.NAME,
						value: user,
					},
					{
						id: FILDS_ZENDEKS.DOCUMENT,
						value: document,
					},
					{
						id: FILDS_ZENDEKS.REASON,
						value: "Problema",
					},
					{
						id: FILDS_ZENDEKS.PROBLEM,
						value: "Cadastro",
					},
					{
						id: FILDS_ZENDEKS.ENROLL,
						value: "Recuperação de conta",
					},
					{
						id: FILDS_ZENDEKS.ENROLL,
						value: "recuperacao_de_conta",
					},
				],
				priority: "high",
				type: "problem",
			},
		};

		if (!isDataEmpty) {
			dispatch(sendTicket(payload));
		} else {
			toast.error("Preencha todos os campos para abrir o chamado");
		}
	}

	function handleChange(isOpen) {
		if (!isOpen) {
			clearErrors();
			reset();
			setIsDataEmpty(true);
		}
	}

	function handleValidField(value, field) {
		const action = {
			document: () => {
				const document = String(value.replace(/\.|-|_/g, ""));

				const isValid = isCPFValid(document);
				if (!isValid && document.length >= 11) {
					setError(field, { message: "CPF inválido, revise o documento" });
				} else {
					clearErrors(field);
				}
			},
			default: () => {},
		};

		(action[field] || action.default)();
	}

	const OptionSelected = useMemo(
		() =>
			alternative === "Telefone" && (
				<Input
					label="E-mail"
					placeholder="Informe seu e-mail atual"
					fieldRegister="userContact"
					register={register}
				/>
			),
		[alternative]
	);

	const SupportForm = useMemo(
		() =>
			isDesktop && (
				<TmPopover
					labelButton="Ajuda"
					iconButton="MdHelpOutline"
					onChange={handleChange}
					forceClose={statePopover}
				>
					<TmPopoverHeader
						onClick={() => setStatePopover(!statePopover)}
						showCloseButton
					>
						Fale conosco
					</TmPopoverHeader>
					<TmPopoverBody>
						<FormSupport onSubmit={handleSubmit(submit)}>
							<Controller
								name="document"
								control={control}
								render={({ field }) => (
									<Input
										{...field}
										label="CPF"
										placeholder="Informe seu CPF"
										mask="999.999.999-99"
										maxLength={28}
										errorMessage={
											formState
												.errors
												.document
										}
									/>
								)}
							/>
							<Input
								label="Nome completo"
								placeholder="Informe seu nome completo"
								fieldRegister="user"
								register={register}
							/>
							<Select
								label="Alterar dados"
								placeholder="Selecione o que deseja alterar"
								defaultValue={{
									value: "e-mail",
									label: "E-mail",
								}}
								onChange={(item) =>
									setValue(
										"alternative",
										item.label
									)
								}
								options={[
									{
										value: "e-mail",
										label: "E-mail",
									},
									{
										value: "phone",
										label: "Telefone",
									},
								]}
							/>
							{OptionSelected}
							<Input
								label={`${selectedField} antigo`}
								placeholder={`Informe seu ${String(selectedField).toLowerCase()} antigo`}
								fieldRegister="oldData"
								register={register}
							/>
							<Input
								label={`${selectedField} novo`}
								placeholder={`Informe seu ${String(selectedField).toLowerCase()} novo`}
								fieldRegister="newData"
								register={register}
							/>
							<Controller
								name="dtBirthday"
								control={control}
								render={({ field }) => (
									<Input
										{...field}
										label="Data de nascimento"
										placeholder="Informe sua data de nascimento"
										mask="99/99/9999"
										maxLength={20}
									/>
								)}
							/>
							<Button
								title="Enviar"
								type="submit"
								loading={ticketLoading}
								disabled={
									isDataEmpty ||
									(formState.errors &&
										Object.keys(
											formState.errors
										).length)
								}
							/>
						</FormSupport>
					</TmPopoverBody>
				</TmPopover>
			),
		[alternative, selectedField, isDataEmpty, formState]
	);

	return (
		<Container id="recover">
			<Wrapper>
				<OnboardStep />
				<Box>
					<Content>
						<Title>Recuperar senha</Title>
						<Subtitle>
							Vamos enviar um código por SMS ou e-mail
							cadastrado
						</Subtitle>
						<FormGroupInput>
							<Label>CPF ou RNE</Label>
							<InputCpf
								value={valueDocument}
								onChange={(param) =>
									onChangeCpf(
										param.target.value
									)
								}
								onBlur={(param) =>
									validDocument(param.target)
								}
								mask={maskCpf}
								error={{ value: !inputCpfValid }}
							/>
							<MessageError>{statusError}</MessageError>
						</FormGroupInput>
						{selectRecover === "SMS" ? (
							<DivButton>
								<ButtonActive
									onClick={() =>
										selectOptionRecover(
											"SMS"
										)
									}
								>
									SMS
								</ButtonActive>
								<ButtonInactive
									onClick={() =>
										selectOptionRecover(
											"email"
										)
									}
								>
									E-mail
								</ButtonInactive>
							</DivButton>
						) : (
							<DivButton>
								<ButtonInactive
									onClick={() =>
										selectOptionRecover(
											"SMS"
										)
									}
								>
									SMS
								</ButtonInactive>
								<ButtonActive
									onClick={() =>
										selectOptionRecover(
											"email"
										)
									}
								>
									E-mail
								</ButtonActive>
							</DivButton>
						)}
						{selectRecover === "SMS" ? (
							<FormGroupInput>
								<Label>DDD + Número de celular</Label>
								<Phone
									numberPhone={telephone}
									onChange={(param) => {
										setPhoneInvalid(
											validatingMaxBrazilianPhoneLength(
												param
											)
										);
										setTelephone(param);
										dispatch(
											showMessageRecoverFailed(
												false
											)
										);
									}}
									error={
										recoverFail.error ||
										Boolean(
											phoneInvalid.length
										)
									}
								/>
								<MessageError>
									{(recoverFail.error &&
										recoverFail.message) ||
										phoneInvalid}
								</MessageError>
							</FormGroupInput>
						) : (
							<FormGroupInput>
								<Label>E-mail</Label>
								<InputText
									error={{
										value: recoverFail.error,
									}}
									name="E-mail"
									id="E-mail"
									value={email}
									disabled={disableInputs}
									onChange={(email) =>
										setEmail(
											email
												.target
												.value
										)
									}
								/>
								<MessageError>
									{recoverFail.error &&
										recoverFail.message}
								</MessageError>
							</FormGroupInput>
						)}

						<Recaptcha
							isValid={(param) => setIsValidCaptcha(param)}
							token={setTokenRecaptcha}
						/>

						<FormSubmit>
							<Button
								title="Enviar código"
								onClick={() => sendPhone()}
								disabled={
									disableButton ||
									Boolean(phoneInvalid.length)
								}
								loading={loading}
							></Button>
						</FormSubmit>
						<HelpContainer>
							<TitleHelp>
								Mudou seu telefone e seu e-mail?
							</TitleHelp>

							{device.isMobile ? (
								<Subtitle>
									<a onClick={handleClick}>
										Clique aqui
									</a>{" "}
									que nossa equipe vai te ajudar
									a restaurar o acesso à sua
									conta!
								</Subtitle>
							) : (
								<Subtitle>
									Clique no botão “Ajuda” no
									canto inferior direito da tela
									e preencha os campos para
									nossa equipe te ajudar a
									restaurar o acesso a sua
									conta!
								</Subtitle>
							)}
						</HelpContainer>
					</Content>
				</Box>
			</Wrapper>
			{/* {SupportForm} */}
		</Container>
	);
}
